import React, { useContext, useState } from 'react';

import { ArrowLeft } from '@zooplus/icons';
import { Checkbox, IconButton, PrimaryButton, SecondaryButton } from '@zooplus/ui-components';

import LocResourcesContext from '../../../common/contexts/LocResourcesContext';
import FiltersContext from '../../contexts/FiltersContext';
import { NumberOfPetType, NumberOfProductType } from '../../types';

export type View = 'ProductTypes' | 'PetTypes' | 'all';

export type ListSelectorProps = {
  title: string;
  view: View;
  setView: (view: View) => void;
};

export const ListSelector = ({ title, view, setView }: ListSelectorProps) => {
  const { onFormatLocale } = useContext(LocResourcesContext);
  const filtersContext: any = useContext(FiltersContext);
  const onSetSelectedGroup = filtersContext[`onSelect${view}`];
  const groups: NumberOfProductType[] | NumberOfPetType[] = filtersContext[view];
  const selectedGroups = filtersContext[`selected${view}`];
  const [groupsSelectedState, setGroupsSelectedState] = useState<string[]>(selectedGroups);

  const onDisableSave = (groupId: string) => {
    return selectedGroups.includes(groupId) && groupsSelectedState.includes(groupId);
  };
  const onSave = () => {
    onSetSelectedGroup(groupsSelectedState);
    setView('all');
  };
  const onAddGroup = (groupId: string) => {
    setGroupsSelectedState([...groupsSelectedState, groupId]);
  };
  const onRemoveGroup = (groupId: string) => {
    setGroupsSelectedState(groupsSelectedState.filter((item) => item !== groupId));
  };

  return (
    <div className="listSelector">
      <div className="header">
        <IconButton
          ariaLabel={onFormatLocale ? onFormatLocale?.('loy.rewards.shop.filter.goBackButton') : ''}
          variant="ghost"
          onClick={() => setView('all')}>
          <ArrowLeft />
        </IconButton>
        <h3 className="title">{onFormatLocale?.(title)}</h3>
      </div>
      <ul className="list">
        {groups.map((group) => (
          <li key={`key-${group.item.title}`} className="group">
            <Checkbox
              id={`${group.item.title}-checkbox`}
              onChange={(e) =>
                e.target.checked ? onAddGroup(group.item.title) : onRemoveGroup(group.item.title)
              }
              checked={groupsSelectedState.includes(group.item.title)}>
              {group.item.title}
            </Checkbox>
            <span
              aria-label={onFormatLocale?.('loy.rewards.shop.filter.numberOfItems', {
                number: group.numberOfArticles,
              })}>{`(${group.numberOfArticles})`}</span>
          </li>
        ))}
      </ul>
      <div className="footer">
        <SecondaryButton
          length="full"
          onClick={() => setGroupsSelectedState([])}
          disabled={groupsSelectedState.length === 0}>
          {onFormatLocale?.('loy.rewards.shop.filter.clear')}
        </SecondaryButton>
        <PrimaryButton
          length="full"
          onClick={() => onSave()}
          disabled={
            groupsSelectedState.every(onDisableSave) && selectedGroups.every(onDisableSave)
          }>
          {onFormatLocale?.('loy.rewards.shop.filter.save')}
        </PrimaryButton>
      </div>
    </div>
  );
};
